import { styled, Switch } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Helix themed Switch.
 */
export const HelixToggleSwitch = styled(Switch)(() => ({
    overflow: 'visible',
    width: 32,
    height: 18,
    padding: 0,
    '&:hover': {
        '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
                '& + .MuiSwitch-track': {
                    backgroundColor: HelixPalette.teal70,
                    borderColor: HelixPalette.teal70,
                },
            },
            '& + .MuiSwitch-track': {
                borderColor: HelixPalette.teal70,
            },
        },
    },
    '&:active:focus-within': {
        '& .MuiSwitch-switchBase': {
            '&.Mui-checked': {
                '& + .MuiSwitch-track': {
                    backgroundColor: HelixPalette.teal90,
                    borderColor: HelixPalette.teal90,
                },
            },
            '& + .MuiSwitch-track': {
                borderColor: HelixPalette.teal90,
            },
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 4,
        transitionDuration: '300ms',
        '.MuiSwitch-input': {
            height: 18,
            width: 32,
            left: -4,
            top: -4,
        },
        '&.Mui-checked': {
            transform: 'translateX(14px)',
            color: HelixPalette.white,
            '.MuiSwitch-input': {
                left: -18,
            },
            '& + .MuiSwitch-track': {
                backgroundColor: HelixPalette.teal80,
                opacity: 1,
                border: `2px solid ${HelixPalette.teal80}`,
                transition: 'background-color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            },
            '& .MuiSwitch-thumb': {
                color: HelixPalette.white,
                transition: 'color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                backgroundColor: HelixPalette.neutral50,
                borderColor: HelixPalette.neutral50,
                opacity: 1,
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: HelixPalette.neutral10,
            },
        },
        '&.Mui-focusVisible': {
            '+ .MuiSwitch-track': {
                outline: HelixStyles.focusVisible4.outline,
                outlineOffset: HelixStyles.focusVisible4.outlineOffset,
            },
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: HelixPalette.neutral50,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: HelixPalette.neutral10,
            borderColor: HelixPalette.neutral50,
            opacity: 1,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        boxShadow: 'none',
        width: 10,
        height: 10,
        color: HelixPalette.neutral50,
        transition: 'color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '& .MuiSwitch-track': {
        borderRadius: 18 / 2,
        backgroundColor: HelixPalette.white,
        opacity: 1,
        transition: 'background-color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        border: `2px solid ${HelixPalette.neutral50}`,
    },
}));
